/*jshint browserify: true */
'use strict';

var Page = (function PageClosure() {

    /**
     * For managing PDF page rendering to a HTML canvas.
     *
     * @param {PDFPageProxy} pageProxy - A PDF.JS page proxy
     * @param {Number} pageNumber
     * @param {HTMLElement} containerElement - The element containing both the page and overlay
     * @param {HTMLElement} pdfCanvasElement - HTML canvas element for rendering the PDF to
     * @param {HTMLElement} pdfOverlayCanvasElement - HTML canvas element for rendering the PDF overlay to
     * @param {Number} scale - Scale for rendering. 1.0 = 100%, 1.5 = 150%, etc.
     */
    function Page(pageProxy, pageNumber, containerElement, pdfCanvasElement, pdfOverlayCanvasElement, scale) {
        var pageViewport = pageProxy.getViewport(scale);
        Object.defineProperty(this, 'pageViewport', {
            get: function () { return pageViewport; }
        });

        /**
         * Scale for rendering. 1.0 = 100%, 1.5 = 150%, etc.
         */
        Object.defineProperty(this, 'scale', {
            get: function () { return pageViewport.scale; },
            set: function (newScale) { pageViewport = pageProxy.getViewport(newScale); }
        });

        this.pageProxy = pageProxy;
        this.pageNumber = pageNumber;
        this.containerElement = containerElement;
        this.pdfCanvasElement = pdfCanvasElement;
        this.pdfOverlayCanvasElement = pdfOverlayCanvasElement;
        this.pdfOverlayCanvasContext = pdfOverlayCanvasElement.getContext('2d');
        this.scale = scale;
    }

    Page.prototype = {
        /**
         * Begins the process of rendering a page to the HTML canvas.
         *
         * @return {RenderTask} A PDF.JS promise object, which is resolved when the page finishes rendering.
         */
        renderPage: function () {
            this.containerElement.style.width = this.pageViewport.width + 'px';
            this.containerElement.style.height = this.pageViewport.height + 'px';
            this.pdfCanvasElement.width = this.pageViewport.width;
            this.pdfCanvasElement.height = this.pageViewport.height;
            this.pdfOverlayCanvasElement.width = this.pageViewport.width;
            this.pdfOverlayCanvasElement.height = this.pageViewport.height;

            return this.pageProxy.render({
                canvasContext: this.pdfCanvasElement.getContext('2d'),
                viewport: this.pageViewport
            });
        }
    };

    return Page;
})();

module.exports = Page;